import React from 'react';
import { useLocation } from 'react-router-dom';

import SkillBigTopLoading from './sharedComponents/SkillBigTopLoading.js';
import { shouldUseBigTopRouteLoader } from '../../themes/bigTopRollout.js';
import { isBackstageLoaderRoute, BACKSTAGE_LOADER_MESSAGE } from '../../themes/teacherViewRollout.js';

/**
 * Route-specific copy for the big-top Suspense / auth / init loader.
 *
 * @param {string} pathname
 */
export function getBigTopRouteLoaderMessage(pathname) {
  if (pathname === '/logout' || pathname.startsWith('/logout/')) {
    return 'Closing the big top . . .';
  }

  if (pathname === '/skillComplete' || pathname.startsWith('/skillComplete/')) {
    return 'Summoning your results . . .';
  }

  if (pathname === '/progressFeedback' || pathname.startsWith('/progressFeedback/')) {
    return 'Preparing your feedback . . .';
  }

  if (isBackstageLoaderRoute(pathname)) {
    return BACKSTAGE_LOADER_MESSAGE;
  }

  return 'The show is about to begin!';
}

/**
 * Shared loading UI for React Suspense, auth gates, and other route-level waits.
 * Big-top and teacher/admin routes get the gold-star loader; legacy routes keep plain text.
 */
export default function RouteLoadingFallback() {
  const location = useLocation();
  const useStarLoader = shouldUseBigTopRouteLoader(location.pathname, location.state)
    || isBackstageLoaderRoute(location.pathname);

  if (useStarLoader) {
    return (
      <SkillBigTopLoading message={getBigTopRouteLoaderMessage(location.pathname)} />
    );
  }

  return <div>Loading...</div>;
}
